import { inject, NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@NgModule({})
export class DataTerminalIconsModule {
    readonly #iconRegistry = inject(MatIconRegistry);
    readonly #domSanitizer = inject(DomSanitizer);

    readonly #NAME_SPACE = 'dc';

    readonly #ICONS = [
        ['plate', 'assets/task-types/plate.svg'],
        ['plateTrolley', 'assets/task-types/platetrolley.svg'],
        ['substrate', 'assets/task-types/substrate.svg'],
    ];

    public constructor() {
        this.#ICONS.forEach((icon) => {
            this.#iconRegistry.addSvgIconInNamespace(
                this.#NAME_SPACE,
                icon[0],
                this.#domSanitizer.bypassSecurityTrustResourceUrl(icon[1])
            );
        });
    }
}
